export class DxOption {
  key;
  description;

  constructor (key, description) {
    this.key = key
    this.description = description
  }
}
